import React from "react";

export const nevRemoteAuthDetailExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '姓名',
    field: 'fullName',
    width: 10,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
      font: {}
    },
  },
  {
    headerName: '账号',
    field: 'userName',
    width: 15,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: "组织名称",
    field: "orgName",
    width: 30,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: "组织编码",
    field: "orgCode",
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '岗位',
    field: 'positionBrandName',
    width: 20,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证场次',
    field: 'name',
    width: 25,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证日期',
    field: 'authDateStr',
    width: 15,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证时间',
    field: 'authTimeStr',
    width: 25,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    },
  },
  {
    headerName: '分配状态',
    field: 'distributionStateStr',
    width: 10,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '讲师',
    field: 'lectureFullName',
    width: 20,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '状态',
    field: 'scoreStateStr',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '总得分',
    field: 'score',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '通过状态',
    field: 'passStr',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  }
];


export const lectureNevAuthDetailExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '姓名',
    field: 'fullName',
    width: 10,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
      font: {}
    },
  },
  {
    headerName: '账号',
    field: 'userName',
    width: 15,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '手机号',
    field: 'mobile',
    width: 15,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: "组织名称",
    field: "orgName",
    width: 30,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: "组织编码",
    field: "orgCode",
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '岗位',
    field: 'positionName',
    width: 20,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证场次',
    field: 'name',
    width: 25,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证日期',
    field: 'authDateStr',
    width: 15,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '认证时间',
    field: 'authTimeStr',
    width: 25,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center', wrapText: true },
    },
  },
  {
    headerName: '状态',
    field: 'scoreStateStr',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '总得分',
    field: 'score',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  },
  {
    headerName: '通过状态',
    field: 'passStr',
    width: 12,
    cellStyle: {
      textAlign: 'left',
    },
    style: {
      alignment: { vertical: 'middle', horizontal: 'center' },
    },
  }
];
